import React, { useEffect, useState } from "react";
import { api, coverUrl, API } from "../lib/api";
import { Link } from "react-router-dom";
import { Download } from "lucide-react";

export default function Library() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/library").then((r) => setItems(r.data.items)).finally(() => setLoading(false));
  }, []);

  const download = async (pid, title) => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API}/library/${pid}/download`, {
        credentials: "include",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!res.ok) throw new Error("Download failed");
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `${title}.pdf`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch { alert("Download failed"); }
  };

  return (
    <div className="container-page py-10" data-testid="library-page">
      <h1 className="font-display text-4xl tracking-tight border-b border-border pb-3 mb-8">My library</h1>
      {loading ? <div className="text-sm text-muted-foreground">Loading…</div> :
       items.length === 0 ? (
        <div className="text-center py-24 border border-dashed border-border rounded-sm">
          <div className="font-display text-3xl">Your library is empty.</div>
          <div className="text-sm text-muted-foreground mt-2 italic">Purchases appear here for instant download.</div>
          <Link to="/browse" className="inline-block mt-6 bg-primary text-primary-foreground px-5 py-2.5 text-sm rounded-sm uppercase tracking-wide">Find your first read</Link>
        </div>
      ) : (
        <div className="product-grid">
          {items.map((p) => (
            <div key={p.id} className="flex flex-col gap-3" data-testid={`lib-item-${p.id}`}>
              <Link to={`/product/${p.id}`} className="aspect-[2/3] bg-muted overflow-hidden rounded-sm border border-accent/30 shadow-[0_8px_24px_-12px_rgba(58,31,71,0.3)]">
                <img src={coverUrl(p)} alt={p.title} className="object-cover w-full h-full hover:scale-105 transition-transform duration-500" />
              </Link>
              <div className="font-display text-base line-clamp-2">{p.title}</div>
              {p.subtitle && <div className="text-xs text-muted-foreground italic line-clamp-1">{p.subtitle}</div>}
              <button onClick={() => download(p.id, p.title)} className="mt-1 inline-flex items-center justify-center gap-2 text-xs font-medium border border-border rounded-sm px-3 py-2.5 hover:bg-muted transition-colors uppercase tracking-wide" data-testid={`download-${p.id}`}>
                <Download className="h-3.5 w-3.5" strokeWidth={1.5} /> Download
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
